import React from 'react';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import CloseIcon from '@material-ui/icons/Close';

import {OnModalTrigger} from '../MediaOrdersTypes';
import './MediaOrderImportProgress.scss';

interface MediaOrderImportProgressProps {
    handleClose: OnModalTrigger;
}

export default function MediaOrderImportProgress({handleClose}: MediaOrderImportProgressProps) {
    return (
        <Grid
            container
            className="grid-container"
            direction="row"
            alignItems="center"
        >
            <LinearProgress
                variant="query"
                className="grid-container__progress"
            />
            <IconButton
                className="grid-container__button grid-container__button_close"
                color="secondary"
                onClick={handleClose}
            >
                <CloseIcon />
            </IconButton>
        </Grid>
    );
}
